#import "../fragments/ImageFragment.gql"
#import "../fragments/URLFragment.gql"
fragment StudioFragment on Studio {
  id
  name
  aliases
  parent {
    id
    name
  }
  urls {
    ...URLFragment
  }
  images {
    ...ImageFragment
  }
  deleted
  is_favorite
}
